
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34756',
  depVersions: {
  "documents-public-ui": "static-1.34756",
  "atom": "static-1.5178",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2601",
  "client-types": "static-1.479",
  "cssUtils": "static-1.821",
  "customer-data-filters-ui": "static-1.40131",
  "customer-data-objects": "static-1.7783",
  "customer-data-property-utils": "static-1.8199",
  "documents-lib": "static-1.34761",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.344",
  "FormsCommonComponents": "static-1.86111",
  "FormUrlGenerator": "static-2.4825",
  "foundations-theming-specialty": "static-1.2249",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5695",
  "hs-test-utils": "static-1.8122",
  "hub-http": "static-1.6325",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11884",
  "HubStyleTokens": "static-2.11577",
  "I18n": "static-7.1635",
  "icons": "static-2.652",
  "jasmine-immutable": "static-1.3124",
  "jasmine-runner": "static-1.6562",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7256",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5501",
  "quartz": "static-1.7158",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16786",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5418",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8277",
  "reference-resolvers-lite": "static-1.8201",
  "reporting-data": "static-1.67954",
  "reporting-reports": "static-1.67632",
  "reporting-snowflake": "static-1.56572",
  "reporting-testing-lib": "static-1.9887",
  "reporting-visualizations": "static-1.60030",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9049",
  "sanitize": "static-1.4580",
  "sanitize-text": "static-1.8248",
  "self-service-api": "static-1.10351",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1848",
  "signup-constants": "static-1.19076",
  "signup-ui-url-generator": "static-2.8160",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4864",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4864",
  "ui-addon-form-validation": "static-1.11093",
  "ui-asset-management-lib": "static-1.11164",
  "ui-images": "static-2.1178",
  "UIComponents": "static-3.8523",
  "usage-tracker": "static-1.7452",
  "usage-tracker-container": "static-1.7442",
  "usage-tracker-core": "static-1.7302",
  "viral-links-lib": "static-1.7172",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9766",
  "foundations-components": "static-1.8131",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.936",
  "quartz-core": "static-1.6377",
  "quick-fetch": "static-1.3993",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4757",
  "ui-addon-i18n": "static-1.11253",
  "ui-addon-upgrades": "static-9.18135",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3473",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3435",
  "quartz-webpack": "static-1.3382",
  "foundations-assets": "static-1.4975",
  "foundations-theming": "static-1.4533",
  "hub-http-shared-msw-handlers": "static-1.10209",
  "hubspotter-http": "static-1.4727",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7352",
  "crm-message-bus": "static-1.43238",
  "customer-data-filters-ui-msw-helpers": "static-1.22566",
  "customer-data-objects-ui-components": "static-1.13133",
  "customer-data-reference-ui-components": "static-1.13275",
  "customer-data-ui-utilities": "static-1.9929",
  "events-data-lib": "static-1.335",
  "framework-builder-read-service-client": "static-1.4080",
  "framework-data-schema-quick-fetch": "static-1.6898",
  "framework-data-schema-resolvers": "static-1.6993",
  "inbound-db-meta-service-client": "static-1.3662",
  "inbound-db-properties-service-client": "static-1.3921",
  "multi-account-reference-resolvers": "static-1.1086",
  "onboarding-tours": "static-1.16790",
  "reporting-datasets-permissions-lib": "static-1.13964",
  "ui-addon-teams": "static-1.21684",
  "quartz-auth": "static-1.833",
  "ui-business-units-lib": "static-1.9165",
  "usage-tracker-session-replay": "static-1.5138",
  "ai-components-ui-library": "static-1.9204",
  "ContentUtils": "static-1.68646",
  "customer-data-properties": "static-1.51918",
  "forms-ai-lib": "static-1.4476",
  "forms-utils-lib": "static-1.12770",
  "foundations-components-test-utils": "static-1.5614",
  "react-dnd-compat": "static-1.4719",
  "react-tinymce": "static-1.55507",
  "tinymce-config": "static-2.54633",
  "ui-gdpr-components": "static-1.10454",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3518",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3233",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.158",
  "ui-fonts": "static-1.839",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4430",
  "csstype": "static-1.50",
  "quartz-head": "static-1.823",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1646",
  "external-options-client-types": "static-1.4205",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.833",
  "frontend-preferences-client": "static-1.8030",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3803",
  "reporting-client-types": "static-1.2564",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25670",
  "hubspot-apollo-client": "static-1.4982",
  "foundations-components-legacy": "static-1.1156",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.588",
  "hs-story-utils": "static-1.9526",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.327",
  "timezone-utils": "static-2.5346",
  "seat-types-lib": "static-1.246",
  "react-create-root-preference": "static-1.33",
  "bend-plugin-foundations-components": "static-1.4400",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2179",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.842",
  "mobile-manifest-mixins": "static-1.541",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.833",
  "quartz-tracking": "static-1.537",
  "trellis-components": "static-1.2198",
  "bend-plugin-chirp-manifest": "static-1.167",
  "chirp-fetch": "static-1.1990",
  "purchase-motions-components": "static-1.6071",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4156",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-foundations-theming": "static-1.3016",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1128",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.277",
  "pulse": "static-1.699",
  "conditional-properties-service-client": "static-1.3872",
  "crm-pipelines-api-client-types": "static-1.4214",
  "fdsr-migration-layer": "static-1.112",
  "multi-currency-client-types": "static-1.3766",
  "getting-started-shared-tasks": "static-1.18688",
  "growth-data-modal": "static-1.5588",
  "growth-onboarding-confetti": "static-1.3169",
  "growth-onboarding-next-action-utils": "static-1.2210",
  "navigation-components": "static-1.18262",
  "onboarding-tours-client": "static-1.5004",
  "onboarding-tours-utils": "static-1.856",
  "ui-shepherd-react": "static-3.10327",
  "ui-shepherd-tracker": "static-1.7708",
  "ui-universal-auth": "static-1.9099",
  "user-context": "static-1.5214",
  "hubspotter-http-shared-msw-handlers": "static-1.10207",
  "magpie-lib": "static-1.5619",
  "navigation-messaging": "static-1.7589",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21770",
  "copilot-toolkit": "static-1.11391",
  "cms-field-types": "static-1.4917",
  "content-icons-ui": "static-1.2255",
  "integrations-lib": "static-1.16480",
  "calling-global-api": "static-1.64855",
  "calling-internal-common": "static-1.31414",
  "calling-lifecycle-internal": "static-1.66237",
  "calling-lifecycle-messages": "static-1.58531",
  "commerce-products-lib": "static-1.9911",
  "crm-links": "static-1.6410",
  "customer-data-properties-shared-msw-handlers": "static-1.9536",
  "file-manager-components": "static-1.23887",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4293",
  "meetings-icalendar-utils-lib": "static-1.738",
  "object-builder-ui-client": "static-1.49088",
  "pipeline-validation-client-types": "static-1.4042",
  "property-value-citations": "static-1.2532",
  "smart-property-lib": "static-1.7721",
  "tiered-pricing": "static-1.1459",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9168",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20004",
  "tinymce-themes": "static-1.56603",
  "data-token-picker": "static-1.16583",
  "hub-http-contrib": "static-1.3146",
  "interframe": "static-3.4864",
  "tinymce-data": "static-1.40718",
  "tinymce-plugins": "static-1.57747",
  "ui-addon-sales-email": "static-1.5314",
  "onboarding-scopes": "static-1.6563",
  "ui-addon-opt": "static-4.8464",
  "apollo-link-hub-http": "static-2.4756",
  "hubspot-apollo-cache": "static-1.441",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.276",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1045",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6074",
  "event-emitter": "static-1.1054",
  "bend-plugin-pulse": "static-1.202",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2133",
  "growth-onboarding-next-action-components": "static-1.2238",
  "user-context-client": "static-1.4685",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5079",
  "nest": "static-1.336",
  "reactive-lib": "static-1.829",
  "simple-logging-lib": "static-1.3154",
  "unified-auth-core-lib": "static-1.895",
  "getting-started-shared-tasks-store": "static-1.17806",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1059",
  "integrations-error-boundary-lib": "static-1.13895",
  "integrations-tracking-lib": "static-1.5709",
  "native-integrations-shared-strings": "static-1.7887",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10466",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.613",
  "calling-error-reporting": "static-1.31421",
  "shared-worker-versioning": "static-1.11139",
  "calling-usage-tracker": "static-1.6647",
  "voice-sms-access-library": "static-1.1392",
  "customer-data-tracking": "static-1.6993",
  "commerce-permissions": "static-1.881",
  "products-iframe-lib": "static-1.8211",
  "products-ui-components-shared-msw-handlers": "static-1.10591",
  "location-customization-utils-lib": "static-1.9550",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4255",
  "video-components-external": "static-1.11601",
  "video-data-lib": "static-1.35259",
  "data-agent-kit": "static-1.358",
  "feedback-loader": "static-1.29481",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10292",
  "fsm": "static-1.3833",
  "policy-lib": "static-1.6885",
  "react-colorpicker": "static-2.10312",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10355",
  "FileManagerLib": "static-1.39527",
  "NamespacedHubStyle": "static-2.9132",
  "FileManagerCore": "static-1.39386",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7913",
  "layout-dnd-components": "static-1.12637",
  "layout-dnd-utils": "static-1.11612",
  "react-codemirror": "static-1.10731",
  "ui-addon-emoji-picker": "static-1.9990",
  "ui-brand-identity-lib": "static-1.15632",
  "InboxConnectUtils": "static-4.15074",
  "meetings-connect-utils-lib": "static-1.7708",
  "breeze-engine-core": "static-1.337",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3121",
  "ads-unified-auth-lib": "static-1.319",
  "google-sheets-integration-lib": "static-1.530",
  "microsoft-drive-integration-lib": "static-1.665",
  "slack-ui-library": "static-1.10497",
  "calling-orchestration-schema": "static-1.36169",
  "sales-views-client-types": "static-1.4359",
  "crm-record-cards-service-types": "static-1.3665",
  "content-media-composition-data-lib": "static-1.12627",
  "content-media-compositions": "static-2.16634",
  "media-bridge-lib": "static-1.19099",
  "trellis-story-utils": "static-1.4616",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6070",
  "FileManagerImages": "static-1.37038",
  "video-components": "static-1.13603",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4640",
  "video-embed": "static-1.36093",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8807",
  "ui-coaching-tips": "static-1.28838",
  "ContentData": "static-1.68721",
  "layout-data-lib": "static-1.9937",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22318",
  "outpost": "static-1.4274",
  "growth-onboarding-feedback-components": "static-1.6683",
  "advanced-menus-core": "static-1.15290",
  "advanced-menus-lib": "static-1.12204",
  "ExportDialog": "static-6.10483",
  "ui-memberships-settings-lib": "static-1.34315",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15289",
  "simple-menus-lib": "static-1.16806"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34756",
  "atom": "/atom/static-1.5178",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2601",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.821",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40131",
  "customer-data-objects": "/customer-data-objects/static-1.7783",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8199",
  "documents-lib": "/documents-lib/static-1.34761",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.344",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4825",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2249",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5695",
  "hs-test-utils": "/hs-test-utils/static-1.8122",
  "hub-http": "/hub-http/static-1.6325",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11884",
  "HubStyleTokens": "/HubStyleTokens/static-2.11577",
  "I18n": "/I18n/static-7.1635",
  "icons": "/icons/static-2.652",
  "jasmine-immutable": "/jasmine-immutable/static-1.3124",
  "jasmine-runner": "/jasmine-runner/static-1.6562",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7256",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5501",
  "quartz": "/quartz/static-1.7158",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16786",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5418",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8277",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8201",
  "reporting-data": "/reporting-data/static-1.67954",
  "reporting-reports": "/reporting-reports/static-1.67632",
  "reporting-snowflake": "/reporting-snowflake/static-1.56572",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9887",
  "reporting-visualizations": "/reporting-visualizations/static-1.60030",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9049",
  "sanitize": "/sanitize/static-1.4580",
  "sanitize-text": "/sanitize-text/static-1.8248",
  "self-service-api": "/self-service-api/static-1.10351",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1848",
  "signup-constants": "/signup-constants/static-1.19076",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8160",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4864",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4864",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11093",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11164",
  "ui-images": "/ui-images/static-2.1178",
  "UIComponents": "/UIComponents/static-3.8523",
  "usage-tracker": "/usage-tracker/static-1.7452",
  "usage-tracker-container": "/usage-tracker-container/static-1.7442",
  "usage-tracker-core": "/usage-tracker-core/static-1.7302",
  "viral-links-lib": "/viral-links-lib/static-1.7172",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9766",
  "foundations-components": "/foundations-components/static-1.8131",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.936",
  "quartz-core": "/quartz-core/static-1.6377",
  "quick-fetch": "/quick-fetch/static-1.3993",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4757",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11253",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18135",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3473",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3435",
  "quartz-webpack": "/quartz-webpack/static-1.3382",
  "foundations-assets": "/foundations-assets/static-1.4975",
  "foundations-theming": "/foundations-theming/static-1.4533",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10209",
  "hubspotter-http": "/hubspotter-http/static-1.4727",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7352",
  "crm-message-bus": "/crm-message-bus/static-1.43238",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22566",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13133",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13275",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9929",
  "events-data-lib": "/events-data-lib/static-1.335",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4080",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6898",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6993",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3662",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3921",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1086",
  "onboarding-tours": "/onboarding-tours/static-1.16790",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13964",
  "ui-addon-teams": "/ui-addon-teams/static-1.21684",
  "quartz-auth": "/quartz-auth/static-1.833",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9165",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5138",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9204",
  "ContentUtils": "/ContentUtils/static-1.68646",
  "customer-data-properties": "/customer-data-properties/static-1.51918",
  "forms-ai-lib": "/forms-ai-lib/static-1.4476",
  "forms-utils-lib": "/forms-utils-lib/static-1.12770",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5614",
  "react-dnd-compat": "/react-dnd-compat/static-1.4719",
  "react-tinymce": "/react-tinymce/static-1.55507",
  "tinymce-config": "/tinymce-config/static-2.54633",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10454",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3518",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3233",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.158",
  "ui-fonts": "/ui-fonts/static-1.839",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4430",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.823",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1646",
  "external-options-client-types": "/external-options-client-types/static-1.4205",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.833",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8030",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3803",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25670",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4982",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1156",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.588",
  "hs-story-utils": "/hs-story-utils/static-1.9526",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.327",
  "timezone-utils": "/timezone-utils/static-2.5346",
  "seat-types-lib": "/seat-types-lib/static-1.246",
  "react-create-root-preference": "/react-create-root-preference/static-1.33",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4400",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2179",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.842",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.541",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.833",
  "quartz-tracking": "/quartz-tracking/static-1.537",
  "trellis-components": "/trellis-components/static-1.2198",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.167",
  "chirp-fetch": "/chirp-fetch/static-1.1990",
  "purchase-motions-components": "/purchase-motions-components/static-1.6071",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4156",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3016",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1128",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.277",
  "pulse": "/pulse/static-1.699",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3872",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4214",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.112",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3766",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18688",
  "growth-data-modal": "/growth-data-modal/static-1.5588",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3169",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2210",
  "navigation-components": "/navigation-components/static-1.18262",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5004",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.856",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10327",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7708",
  "ui-universal-auth": "/ui-universal-auth/static-1.9099",
  "user-context": "/user-context/static-1.5214",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10207",
  "magpie-lib": "/magpie-lib/static-1.5619",
  "navigation-messaging": "/navigation-messaging/static-1.7589",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21770",
  "copilot-toolkit": "/copilot-toolkit/static-1.11391",
  "cms-field-types": "/cms-field-types/static-1.4917",
  "content-icons-ui": "/content-icons-ui/static-1.2255",
  "integrations-lib": "/integrations-lib/static-1.16480",
  "calling-global-api": "/calling-global-api/static-1.64855",
  "calling-internal-common": "/calling-internal-common/static-1.31414",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66237",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58531",
  "commerce-products-lib": "/commerce-products-lib/static-1.9911",
  "crm-links": "/crm-links/static-1.6410",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9536",
  "file-manager-components": "/file-manager-components/static-1.23887",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4293",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.738",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49088",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4042",
  "property-value-citations": "/property-value-citations/static-1.2532",
  "smart-property-lib": "/smart-property-lib/static-1.7721",
  "tiered-pricing": "/tiered-pricing/static-1.1459",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9168",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20004",
  "tinymce-themes": "/tinymce-themes/static-1.56603",
  "data-token-picker": "/data-token-picker/static-1.16583",
  "hub-http-contrib": "/hub-http-contrib/static-1.3146",
  "interframe": "/interframe/static-3.4864",
  "tinymce-data": "/tinymce-data/static-1.40718",
  "tinymce-plugins": "/tinymce-plugins/static-1.57747",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5314",
  "onboarding-scopes": "/onboarding-scopes/static-1.6563",
  "ui-addon-opt": "/ui-addon-opt/static-4.8464",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4756",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.441",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.276",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1045",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6074",
  "event-emitter": "/event-emitter/static-1.1054",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.202",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2133",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2238",
  "user-context-client": "/user-context-client/static-1.4685",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5079",
  "nest": "/nest/static-1.336",
  "reactive-lib": "/reactive-lib/static-1.829",
  "simple-logging-lib": "/simple-logging-lib/static-1.3154",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.895",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17806",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1059",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13895",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5709",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7887",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10466",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.613",
  "calling-error-reporting": "/calling-error-reporting/static-1.31421",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11139",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6647",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1392",
  "customer-data-tracking": "/customer-data-tracking/static-1.6993",
  "commerce-permissions": "/commerce-permissions/static-1.881",
  "products-iframe-lib": "/products-iframe-lib/static-1.8211",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10591",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9550",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4255",
  "video-components-external": "/video-components-external/static-1.11601",
  "video-data-lib": "/video-data-lib/static-1.35259",
  "data-agent-kit": "/data-agent-kit/static-1.358",
  "feedback-loader": "/feedback-loader/static-1.29481",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10292",
  "fsm": "/fsm/static-1.3833",
  "policy-lib": "/policy-lib/static-1.6885",
  "react-colorpicker": "/react-colorpicker/static-2.10312",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10355",
  "FileManagerLib": "/FileManagerLib/static-1.39527",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9132",
  "FileManagerCore": "/FileManagerCore/static-1.39386",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7913",
  "layout-dnd-components": "/layout-dnd-components/static-1.12637",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11612",
  "react-codemirror": "/react-codemirror/static-1.10731",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9990",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15632",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15074",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7708",
  "breeze-engine-core": "/breeze-engine-core/static-1.337",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3121",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.319",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.530",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.665",
  "slack-ui-library": "/slack-ui-library/static-1.10497",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36169",
  "sales-views-client-types": "/sales-views-client-types/static-1.4359",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3665",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12627",
  "content-media-compositions": "/content-media-compositions/static-2.16634",
  "media-bridge-lib": "/media-bridge-lib/static-1.19099",
  "trellis-story-utils": "/trellis-story-utils/static-1.4616",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6070",
  "FileManagerImages": "/FileManagerImages/static-1.37038",
  "video-components": "/video-components/static-1.13603",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4640",
  "video-embed": "/video-embed/static-1.36093",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8807",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28838",
  "ContentData": "/ContentData/static-1.68721",
  "layout-data-lib": "/layout-data-lib/static-1.9937",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22318",
  "outpost": "/outpost/static-1.4274",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6683",
  "advanced-menus-core": "/advanced-menus-core/static-1.15290",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12204",
  "ExportDialog": "/ExportDialog/static-6.10483",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34315",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15289",
  "simple-menus-lib": "/simple-menus-lib/static-1.16806"
}
};
